import { ApiResponse } from "./wall";
import { axiosInstance } from "utils";
import { IdString, INews, ITributeNotification } from "../models/others";

export const getNews = async (): Promise<INews[]> => {
  const response = await axiosInstance.get<ApiResponse<INews>>(`/news/`);

  return response.data.results;
}

export const getTributeNotifications = async (): Promise<ITributeNotification[]> => {
  const response = await axiosInstance.get("tribute-notifications/");

  return response.data.results;
}


export const markTributeNotificationsListRead = async (uuids: IdString[]): Promise<IdString[]> => {
  const response = await axiosInstance.patch("tribute-notifications/mark-read-by-list/", {uuids});

  return response.data.results;
}
